import React, { useEffect, useState } from "react";

// Libraries
// import Preload from "react-preload";

// Styles
import "./App.css";
import "static/scss/main.scss";

// Router
import { Route, Switch } from "react-router-dom";

// Components
import StartScreen from "../src/views/StartScreen";
import Level from "views/Level";
import NextLevel from "views/NextLevel";
import GameComplete from "views/GameComplete";
import Welcome from "views/Welcome";
import ProcLevel from "views/ProcLevel";
import Tutorial2 from "views/Tutorial2";
import LevelView from "views/LevelView";
import NextLevelView from "views/NextLevelView";
import GameCompleteView from "views/GameCompleteView";
import WelcomeView from "views/WelcomeView";
import ProcLevelView from "views/ProcLevelView";
import RunAllView from "views/RunAllView";
import Popup from "components/Popup";
import WelcomeContinued from "views/WelcomeContinued";

// Icons & Images
import PlayIcon from "static/icons/play-icon.png";
import StopIcon from "static/icons/stop-icon.png";
import UpArrow from "static/icons/up-arrow-icon.png";
import RotateClockwiseIcon from "static/icons/rotate-clockwise-icon.png";
import RotateAntiClockwiseIcon from "static/icons/rotate-anticlockwise-icon.png";
import JumpIcon from "static/icons/jump-icon.png";
import LoopIcon from "static/icons/loop-icon.png";
import PotIcon from "static/icons/pot-icon.png";
import PurpleUpArrow from "static/icons/purple-up-arrow-icon.png";
import PurpleRotateClockwiseIcon from "static/icons/purple-rotate-clockwise-icon.png";
import PurpleRotateAntiClockwiseIcon from "static/icons/purple-rotate-anticlockwise-icon.png";
import PurpleJumpIcon from "static/icons/purple-jump-icon.png";
import PurplePotIcon from "static/icons/purple-pot-icon.png";
import PurpleLoopIcon from "static/icons/purple-loop-icon.png";
import RefreshIcon from "static/icons/refresh-icon.png";
import SuccessIcon from "static/icons/success-icon.svg";
import RotatePhone from "static/img/rotate-phone.gif";
import MenuIcon from "static/icons/menu-icon.png";
import CodeBerryLogo from "static/icons/code-berry-logo.png";
import MusicOnIcon from "static/icons/music-on-icon.png";
import MusicOffIcon from "static/icons/music-off-icon.png";
import AlertIcon from "static/icons/alert-icon.svg";
import TealPlayIcon from "static/icons/teal-play-icon.svg";
import StartScreenHeroImages from "static/img/start-screen-hero-images.png";
// import Berry from 'static/img/cactus.svg'
// import Feet from 'static/img/feet.svg'
// import FootSteps from 'static/img/footstep.svg'
import Splatter from "static/img/splatter.svg";
import NotLit from "static/img/pot.svg";
import Lit from "static/img/potted.svg";
import MovePlaceholderSquare from "static/img/move-placeholder-square.svg";
import MovePlaceholderSquarePurple from "static/img/move-placeholder-square-purple.svg";
import LevelPageBackground from "static/img/level-page-background.png";
import LeftStarIcon from "static/icons/left-star-icon.svg";
import MainStarIcon from "static/icons/main-star-icon.svg";
import RightStarIcon from "static/icons/right-star-icon.svg";
import Plant from "static/img/plant.svg";
import Forward from "static/img/forward.svg";
import Clockwise from "static/img/clockwise.svg";
import Anticlockwise from "static/img/anticlockwise.svg";
import Loop from "static/img/loop.svg";
import Jump from "static/img/jump.svg";
import Board from "static/img/board.svg";
import Screen2 from "static/img/screen-2.svg";
import Screen3 from "static/img/screen-3.svg";
import Tut1 from "static/img/tutorial-1.svg";
import Tut2 from "static/img/tutorial-2.svg";
import WhiteSettingsIconWithTimer from "static/icons/white-settings-icon-with-timer.png";
import WhiteHappyFaceIcon from "static/icons/white-happy-face-icon.png";
import QueenBerryIcon from "static/icons/queen-berry-icon.png";
import RIGHT from "static/img/RIGHT.svg";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { GC } from './services/config/gamecentreService';
import { storage } from "services/config/storage";
import { NEW_DATA_EVENT } from "utility/constants";
// import { PreloadImages } from "components/PreloadImages";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [gameDetails, setGameDetails] = useState(null);
  const gameInIframe = (window.location !== window.parent.location);

  const syncData = () => {
    const getGameDetails = storage.get.gameDetails();
    setGameDetails(getGameDetails);
  };

  const handleBlur = () => {
    GC.sendGameBlurredMessage()
  }

  useEffect(() => {
    if (!gameInIframe) {
      // Not calling gamecenter apis if not loaded in it.
      return;
    }
    // Adding timeout to handle React.18 intentinonal re-render on development
    const timeout = setTimeout(() => {
      window.addEventListener("message", GC.messageEventHandler);
      GC.sendGameLoadMessage();
    }, 0);
    window.addEventListener(NEW_DATA_EVENT, syncData);
    window.addEventListener("blur", handleBlur)

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("message", GC.messageEventHandler);
      window.removeEventListener(NEW_DATA_EVENT, syncData);
      window.removeEventListener("blur", handleBlur)
    };
  }, []);

  let imageArr = [
    PlayIcon,
    StopIcon,
    UpArrow,
    RotateClockwiseIcon,
    RotateAntiClockwiseIcon,
    JumpIcon,
    LoopIcon,
    PurplePotIcon,
    PurpleUpArrow,
    PurpleRotateClockwiseIcon,
    PurpleRotateAntiClockwiseIcon,
    PurpleJumpIcon,
    PurpleLoopIcon,
    RefreshIcon,
    SuccessIcon,
    RotatePhone,
    MenuIcon,
    CodeBerryLogo,
    MusicOnIcon,
    MusicOffIcon,
    AlertIcon,
    TealPlayIcon,
    StartScreenHeroImages,
    RIGHT,
    // Berry,
    Splatter,
    NotLit,
    Lit,
    // Feet,
    // FootSteps,
    MovePlaceholderSquare,
    MovePlaceholderSquarePurple,
    LevelPageBackground,
    LeftStarIcon,
    MainStarIcon,
    RightStarIcon,
    PotIcon,
    Plant,
    WhiteSettingsIconWithTimer,
    WhiteHappyFaceIcon,
    QueenBerryIcon,
    Forward,
    Clockwise,
    Anticlockwise,
    Loop,
    Jump,
    Board,
    Screen2,
    Screen3,
    Tut1,
    Tut2,
  ];

  let loader = <div style={{ background: "#7e07f8" }}></div>;

  const cacheImages = async (srcArray) => {
    try {
      // Preload images
      // currently not showing loading screen
      const promises = await srcArray.map((src) => {
        return new Promise((resolve, reject) => {
          const img = new Image();

          img.src = src;
          img.onload = () => resolve(img);
          img.onerror = (e) => reject(e);
        });
      });
      await Promise.allSettled(promises);
    } catch (error) {
      console.error("ERROR ::", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    cacheImages(imageArr);
  }, []);
  /**  
   *  Render game if any two conditions met 
   *  @param {boolean} gameInIframe - Check game window loaded in iframe to call/not call GC/SDK apis
   *  @param {object} gameDetails - (When game loaded in iframe) Make GC/SDK apis call and set gameData/gameDetails,
   *  which dispatch a window NEW_DATA_EVENT, which sets gameDetails { orgName, mediaUrl, gameName } 
*/
  return (
    <Sentry.ErrorBoundary
      onError={(err) => console.log(err)}
      fallback={<p>An error has occurred</p>}
    >
      {/* {isLoading ? (
        loader
      ) : ( */}
      {
        ((!gameInIframe) || (gameDetails)) &&
        <div className="App">
          <Switch>
            <Route exact path="/" component={StartScreen} />
            <Route path="/level" component={Level} />
            <Route path="/nextlevel" component={NextLevel} />
            <Route path="/gamecomplete" component={GameComplete} />
            <Route path="/proclevel" component={ProcLevel} />
            <Route path="/tutorial1" component={Welcome} />
            <Route path="/tutorial2" component={Tutorial2} />
            <Route path="/levelview" component={LevelView} />
            <Route path="/nextlevelview" component={NextLevelView} />
            <Route path="/gamecompleteview" component={GameCompleteView} />
            <Route path="/welcomeview" component={WelcomeView} />
            <Route path="/procLevelview" component={ProcLevelView} />
            <Route path="/runallview" component={RunAllView} />
            <Route path="/welcomecontinued" component={WelcomeContinued} />
            <Route path="/error" component={Popup} />
          </Switch>
        </div>
        }
      {/* )} */}
    </Sentry.ErrorBoundary>
  );
}

export default App;
